<script lang="ts">
import StudySlideResponsiveDataTableCard from '$lib/components/study/cards/StudySlideResponsiveDataTableCard.svelte'
import type { StudyTableSlideProps } from '$lib/components/study/slide-layout-types'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/**
 * Full table slide: `StudySlide` → `StudySlideContent` → `.ey` / `.hl` / optional `.bd` intro /
 * `.cs` + `.hr` (order set by `subtitleAfterHr`) + responsive table + optional `.hb` footnote.
 * `eyebrow`, `headline`, `subtitle`, `introHtml`, and `footnoteHtml` use `{@html}` — trusted copy only.
 */
let props: StudyTableSlideProps = $props()

const eyebrow = props.eyebrow
const headline = props.headline
const subtitle = props.subtitle
const headlineStyle = props.headlineStyle ?? 'margin-bottom:.5rem;'
const subtitleStyle =
  props.subtitleStyle ??
  'margin:0 0 1rem;font-size:.72rem;letter-spacing:.04em;color:var(--mu);text-transform:none;'
const hrStyle = props.hrStyle ?? 'margin-bottom:1rem;'
const introStyle = props.introStyle ?? 'margin-bottom:1rem;'
const subtitleAfterHr = props.subtitleAfterHr ?? false
const footnoteHbStyle = props.footnoteStyle ?? 'margin-top:1rem;'
const footnotePStyle =
  props.footnoteParagraphStyle ?? 'margin:0;font-size:.8rem;line-height:1.5;color:var(--mu);'

const tableProps = $derived(
  props.variant === 'generic'
    ? ({
        variant: 'generic' as const,
        headers: props.headers,
        rows: props.rows,
        columnAlign: props.columnAlign,
      } satisfies import('$lib/components/study/slide-layout-types').StudySlideResponsiveDataTableCardProps)
    : props.variant === 'compare'
      ? ({ variant: 'compare' as const, rows: props.rows } satisfies import('$lib/components/study/slide-layout-types').StudySlideResponsiveDataTableCardProps)
      : ({ variant: 'dictionary' as const, rows: props.rows } satisfies import('$lib/components/study/slide-layout-types').StudySlideResponsiveDataTableCardProps),
)
</script>

<StudySlide
  id={props.id}
  active={props.active}
  extraBottom={props.extraBottom}
  background={props.background}
  slideClass={props.slideClass}
>
  <StudySlideContent
    maxWidth={props.maxWidth}
    textAlign={props.textAlign}
    contentClass={props.contentClass}
    style={props.contentStyle}
  >
    <div class="ey">{@html eyebrow}</div>
    <div class="hl" style={headlineStyle}>{@html headline}</div>
    {#if props.introHtml}
      <p class="bd" style={introStyle}>{@html props.introHtml}</p>
    {/if}
    {#if subtitleAfterHr}
      <div class="hr" style={hrStyle}></div>
      <p class="cs" style={subtitleStyle}>{@html subtitle}</p>
      <StudySlideResponsiveDataTableCard {...tableProps} />
    {:else}
      <p class="cs" style={subtitleStyle}>{@html subtitle}</p>
      <div class="hr" style={hrStyle}></div>
      <StudySlideResponsiveDataTableCard {...tableProps} />
    {/if}
    {#if props.footnoteHtml}
      <div class="hb" style={footnoteHbStyle}>
        <p style={footnotePStyle}>{@html props.footnoteHtml}</p>
      </div>
    {/if}
  </StudySlideContent>
</StudySlide>
